// services/veederRoot.js
import axiosInstance from './axiosInstance';

const VEEDER_ROOT_API_URL = '/veeder-root';

const veederRootService = {
  async get(idempresa, idposto) {
    try {
      const idpostoParam = idposto ? `&idposto=${idposto}` : '';
      const response = await axiosInstance.get(`${VEEDER_ROOT_API_URL}/get.php?idempresa=${idempresa}${idpostoParam}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter dados Veeder Root:', error);
      return [];
    }
  }
};

export default veederRootService;
